<template>
  <CustomModal ref="modal" class="add-credit-note-modal" title="Créer un avoir">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <div class="form-container">
          <div class="form-element">
            <CustomTextField class="title" :content=inputs.title />

            <CustomRadioField style="margin-top: 20px" :content=inputs.action />

            <label class="copy-elements">
              <input type="checkbox" v-model="copyElements" :disabled="inputs.action.value === 'aborted'">
              <span>Reprendre les éléments de la facture en négatif</span>
            </label>

            <div class="copy-information">
              Si cette option est activée, les éléments de la facture seront repris dans l'avoir avec leurs montants inversés.
            </div>
          </div>
        </div>

        <CustomButton class="submit-button" @click="submitForm" :params=buttons.submit style="margin-top: 15px"/>

        <div class="redirect-information">
          Vous serez automatiquement redirigé vers l'édition détaillée de l'avoir.
        </div>
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faXmark, faPlus, faUpLong, faCheck, faExclamation} from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomRadioField from "@/components/forms/customs/customRadioField/CustomRadioField.vue";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";

library.add(faXmark);
library.add(faPlus);
library.add(faCheck);
library.add(faUpLong);
library.add(faExclamation);

export default {
  name: 'AddCreditNoteModal',
  props: ['callback'],
  components: {
    CustomModal,
    CustomForm,
    CustomTextField,
    CustomRadioField,
    CustomButton
  },

  data() {
    return {
      business: undefined,
      copyElements: false,

      inputs: {
        title: {label: 'Titre', value: '', type: 'text', required: true},
        action: {
          label: 'Action',
          value: 'creditNote',
          type: 'radio',
          required: true,
          values: [
            {value: 'aborted', label: 'Annuler la facture et créer un avoir'},
            {value: 'creditNote', label: 'Créer un avoir sans annuler la facture'}
          ]
        }
      },

      buttons: {
        submit: {text: "Créer l'avoir"}
      },

      isTerminateButtonDisplayed: false
    };
  },

  watch: {
    'inputs.action.value'(value) {
      if (value === 'aborted') {
        this.copyElements = true;
      }
    }
  },

  methods: {
    async openModal(business) {
      this.$refs.modal.openModal();
      this.$refs.form?.startLoading();

      this.business = business;
      this.copyElements = false;

      this.inputs.action.value = 'creditNote';
      this.buttons.submit.disabled = false;
      this.inputs.title.value = "Avoir - " + business.title;

      this.$refs.form?.stopLoading();
    },

    closeModal() {
      this.$refs.modal?.closeModal();
    },

    terminate() {
      this.closeModal();
      this.callback();
    },
    async submitForm() {
      const res = await BusinessController.postCreditNote({
        title: this.inputs.title.value,
        creditNoteOfBusinessId: this.business.id,
        action: this.inputs.action.value,
        copyElements: this.copyElements
      });

      if (!res.errors) {
        (new NotificationService).addNotification("success", "Avoir créé");
        this.terminate();
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.form-container
  display flex
  flex-direction column

.form-element
  width 100%

.copy-elements
  display flex
  align-items center
  gap 8px
  margin-top 25px
  cursor pointer

.copy-elements input:disabled
  cursor not-allowed

.copy-information
  margin-top 8px
  color #777
  font-size 13px

.submit-button
  margin 20px auto auto

.redirect-information
  margin-top 12px
  text-align center
  color #777
  font-size 12px

@media only screen and (min-width: DESKTOP_SIZE)
  .form-container
    flex-direction row

  .form-element
    width 100%

  .submit-button
    width 250px
</style>

<style lang="stylus">
.add-credit-note-modal .modal
  width 500px !important
  max-width 90vw !important
</style>